import { createServiceClient } from "./connect";
import {
  AuthService,
  CategoryService,
  ExerciseService,
  ExerciseHistoryService,
  NewBreedService,
  PracticeSessionService,
  SettingsService,
  SrsService,
  TagService,
} from "@/gen/tempus/v1/tempus_pb";

// Create typed clients for all services
export const authClient = createServiceClient(AuthService);
export const categoryClient = createServiceClient(CategoryService);
export const tagClient = createServiceClient(TagService);
export const exerciseClient = createServiceClient(ExerciseService);
export const sessionClient = createServiceClient(PracticeSessionService);
export const historyClient = createServiceClient(ExerciseHistoryService);
export const newBreedClient = createServiceClient(NewBreedService);
export const settingsClient = createServiceClient(SettingsService);
export const srsClient = createServiceClient(SrsService);

// Export for convenience
export const api = {
  auth: authClient,
  categories: categoryClient,
  tags: tagClient,
  exercises: exerciseClient,
  sessions: sessionClient,
  history: historyClient,
  newBreed: newBreedClient,
  settings: settingsClient,
  srs: srsClient,
};

export default api;
